import type { RecueilData } from '../types'
import { impressionDataIntroduction } from '@/impressions/ImpressionDataIntroduction'
import { impressionDataBratMuse } from '@/impressions/ImpressionDataBratMuse'
import { impressionDataPlane } from '@/impressions/ImpressionDataPlane'
import { impressionDataChild } from '@/impressions/ImpressionDataChild'
import { impressionDataPlaneProductivity } from '@/impressions/ImpressionDataPlaneProductivity'
import { impressionDataTrainCrossroads } from '@/impressions/ImpressionDataTrainCrossroads'
import { impressionDataHopeBubble } from '@/impressions/ImpressionDataHopeBubble'
import { impressionDataWordButton } from '@/impressions/ImpressionDataWordButton'
import { impressionDataCoupleHolidays } from '@/impressions/ImpressionDataCoupleHolidays'
import { impressionDataAuRevoir } from '@/impressions/ImpressionDataAuRevoir'
import { impressionDataBoulimie } from '@/impressions/ImpressionDataBoulimie'
import { impressionDataCapsule } from '@/impressions/ImpressionDataCapsule'
import { impressionDataMonolog } from '@/impressions/ImpressionDataMonolog'
import { impressionDataPlocPloc } from '@/impressions/ImpressionDataPlocPloc'
import { impressionDataPointille } from '@/impressions/ImpressionDataPointille'
import { impressionDataColoc } from '@/impressions/ImpressionDataColoc'
import { impressionDataSacDeNoeud } from '@/impressions/ImpressionDataSacDeNoeud'
import { impressionDataEruption } from '@/impressions/ImpressionDataEruption'
import { impressionDataEscalier } from '@/impressions/ImpressionDataEscalier'
import { impressionDataPosteMortem } from '@/impressions/ImpressionPosteMortem'
import { impressionDataExtraLucide } from '@/impressions/ImpressionDataExtraLucide'
import { impressionDataMenage } from '@/impressions/ImpressionDataMenage'
import { impressionDataMarelle } from '@/impressions/ImpressionDataMarelle'
import {impressionData5minutes} from "@/impressions/ImpressionData5minutes";
import {impressionDataAutre5minutes} from "@/impressions/ImpressionDataAutre5minutes";

export const RECUEILS: RecueilData[] = [
  {
    key: 'silences',
    name: 'IMPRESSIONS',
    year: '2023',
    desc: 'Des jets de mots... plutôt joyeux.',
    texts: [
      impressionDataIntroduction,
      impressionDataEscalier,
      impressionDataPlane,
      impressionDataPlocPloc,
      impressionDataHopeBubble,
      impressionDataCoupleHolidays,
      impressionDataPlaneProductivity,
      impressionDataMenage
    ]
  },
  {
    key: 'marees',
    name: 'LIENS',
    year: '2023',
    desc: "Des gens qui restent, des gens qui partent, et ce qui s'use entre les deux.",
    texts: [impressionDataChild]
  },
  {
    key: 'nord',
    name: 'INTÉRIEUR',
    year: '2023',
    desc: 'Et une petite odeur de renfermé...',
    texts: [
      impressionDataWordButton,
      impressionDataBoulimie,
      impressionDataCapsule,
      impressionDataMonolog,
      impressionDataSacDeNoeud,
      impressionDataEruption,
      impressionDataColoc
    ]
  },
  {
    key: 'nord',
    name: 'AMOUR, TOUJOURS !',
    year: '2023',
    desc: "Ahh l'amour... que de joie, de peine... et d'histoire !",
    texts: [impressionDataTrainCrossroads, impressionDataAuRevoir, impressionDataPointille]
  },
  {
    key: 'nord',
    name: 'EROS',
    year: '2023',
    desc: 'Un peu de désir !',
    texts: [impressionDataBratMuse]
  },
  {
    key: 'nord',
    name: 'SEPULTURE : A MA SOEUR',
    year: '2026',
    desc: 'Souvenir et deuil, comme un linceul.',
    texts: [impressionDataPosteMortem, impressionDataExtraLucide, impressionDataMarelle, impressionData5minutes, impressionDataAutre5minutes]
  }
]
